"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = void 0;

const configurations_1 = require("../../configurations");

const chrono_1 = require("../../chrono");

const SlashDateFormatParser_1 = __importDefault(require("../../common/parsers/SlashDateFormatParser"));

const PTWeekdayParser_1 = __importDefault(require("./parsers/PTWeekdayParser"));

const PTTimeExpressionParser_1 = __importDefault(require("./parsers/PTTimeExpressionParser"));

const PTMergeDateTimeRefiner_1 = __importDefault(require("./refiners/PTMergeDateTimeRefiner"));

const PTMergeDateRangeRefiner_1 = __importDefault(require("./refiners/PTMergeDateRangeRefiner"));

const PTMonthNameLittleEndianParser_1 = __importDefault(require("./parsers/PTMonthNameLittleEndianParser"));

const PTCasualDateParser_1 = __importDefault(require("./parsers/PTCasualDateParser"));

const PTCasualTimeParser_1 = __importDefault(require("./parsers/PTCasualTimeParser"));

exports.casual = new chrono_1.Chrono(createCasualConfiguration());
exports.strict = new chrono_1.Chrono(createConfiguration(true));

function parse(text, ref, option) {
  return exports.casual.parse(text, ref, option);
}

exports.parse = parse;

function parseDate(text, ref, option) {
  return exports.casual.parseDate(text, ref, option);
}

exports.parseDate = parseDate;

function createCasualConfiguration(littleEndian = true) {
  const option = createConfiguration(false, littleEndian);
  option.parsers.push(new PTCasualDateParser_1.default());
  option.parsers.push(new PTCasualTimeParser_1.default());
  return option;
}

exports.createCasualConfiguration = createCasualConfiguration;

function createConfiguration(strictMode = true, littleEndian = true) {
  return configurations_1.includeCommonConfiguration({
    parsers: [new SlashDateFormatParser_1.default(littleEndian), new PTWeekdayParser_1.default(), new PTTimeExpressionParser_1.default(), new PTMonthNameLittleEndianParser_1.default()],
    refiners: [new PTMergeDateTimeRefiner_1.default(), new PTMergeDateRangeRefiner_1.default()]
  }, strictMode);
}

exports.createConfiguration = createConfiguration;